enum CategoryType {
  Tried = '0',
  Hottest = '-1',
  FriendRecommend = '-2',
  MemberItem = '-3'
}

export default CategoryType
